import { useBayesianNetworksStore } from '../dal/bayesian-networks-store';
import { calculateBayesianNetworks } from '../domain/bayesian-networks-provider';

const BayesianNetworksView = () => {

    const params = useBayesianNetworksStore(store => store.params);

    const results = calculateBayesianNetworks(params);

    return (
        <div className="flex gap-4 items-start">
            <div>
               {/* <strong className="mb-2">Results:</strong>*/}
                {
                    results.map((result, i) => {
                        return (
                            <div key={ `result-${ i }` } className="border-b pb-4 mb-4">
                                <div className="mb-4 text-xl text-teal-700">{ result.target } = { result.probability }</div>

                                <strong className="mb-4 text-xl">Steps:</strong>
                                <ul>
                                    {
                                        result.steps.map((step, s) => {
                                            return (
                                                <li key={ `result-${ i }-step-${ s }` } className="list-disc ml-4 mb-1 pb-1 border-b">
                                                    { step }
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        )
                    })
                }

            </div>
        </div>
    )
};

export default BayesianNetworksView;